import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AbilityService } from '@casl/angular';
import { Observable, map, of, take } from 'rxjs';

interface CheckPermissionsOptions {
  action: string;
  subject: string;
  url: string;
}

function checkPermissions({
  action,
  subject,
  url,
}: CheckPermissionsOptions): Observable<boolean | UrlTree> {
  const router = inject(Router);
  const abilityService = inject(AbilityService);
  return abilityService.ability$.pipe(
    take(1),
    map((ability) => {
      let rv: boolean | UrlTree;
      const canEnter = ability.can(action, subject);
      if (canEnter) {
        rv = true;
      } else {
        console.warn(
          'unauthorized',
          'action',
          action,
          'subject',
          subject,
          'url',
          url
        );
        rv = router.parseUrl(
          `/unauthorized?action=${action}&subject=${subject}&url=${url}`
        );
      }

      return rv;
    })
  );
}

export const AuthZGuard: CanActivateFn = (route, state) => {
  const action = route.data['action'];
  const subject = route.data['subject'];
  const hasAction = typeof action === 'string' && action.trim().length > 0;
  const hasSubject = typeof subject === 'string' && subject.trim().length > 0;
  let rv: Observable<boolean | UrlTree>;
  if (hasAction && hasSubject) {
    rv = checkPermissions({
      action,
      subject,
      url: state.url,
    });
  } else {
    rv = of(true);
  }

  return rv;
};
